import { render } from "./TextPage.vue?vue&type=template&id=d44bc410"
import script from "./TextPage.vue?vue&type=script&lang=js"
export * from "./TextPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__